import { DatePicker, Form } from 'antd';
import React from 'react';
import { US_LOCALE_DATE_FORMAT } from 'utilities/dates/date';
import { FormItemProps } from 'antd/es/form';
import { CalendarOutlined, LoadingOutlined } from '@ant-design/icons';

interface Props extends FormItemProps<string> {
  placeholder?: string;
  disabled?: boolean;
  loading?: boolean;
}

const styles = { width: '100%' };

export function FieldDate(props: Props) {
  const { name, label, placeholder, required = true, disabled, loading } = props;
  return (
    <Form.Item
      name={name}
      label={label}
      rules={[{ required, message: 'Please select one option' }]}
    >
      <DatePicker
        style={styles}
        format={US_LOCALE_DATE_FORMAT}
        placeholder={placeholder}
        disabled={disabled}
        suffixIcon={loading ? <LoadingOutlined /> : <CalendarOutlined />}
      />
    </Form.Item>
  );
}
